import { render, staticRenderFns } from "./StatsNombreMoyenTransport.vue?vue&type=template&id=b49d8e32&"
import script from "./StatsNombreMoyenTransport.vue?vue&type=script&lang=js&"
export * from "./StatsNombreMoyenTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports